<template>
    <div class="light-color-bg position-relative">
        <QuestionTitle number="06" :question="question"></QuestionTitle>
        <div class="container-70 mt-20px" >
            <HydroOnly v-model="result" @click="saveAndContinue('consommationEnergetiqueHydro', JSON.stringify(result), './question-7')"></HydroOnly>
            <AvancementLine percent="75%" class="mt-50px"></AvancementLine>
        </div>
    </div>
</template>
<script>
import QuestionTitle from '@/components/QuestionTitle.vue'
import AvancementLine from '@/components/AvancementLine.vue'
import HydroOnly from '@/components/HydroOnly.vue'
/*Mixins*/
import utils from '@/mixins/utils'
export default {
    data() {
        return {
            result:null,
            question:'Est-ce que votre évènement utilise uniquement l’hydroélectricité comme source d’énergie?',
        }
    },
    components: {
        QuestionTitle,
        HydroOnly,
        AvancementLine
    },
    mixins:[utils],
    mounted(){
        if(sessionStorage.getItem('evenementNbParticipants')){
            this.result=JSON.parse(sessionStorage.getItem('evenementNbParticipants'))
        }
    }
}
</script>